import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Comment, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeComment(request: Boundaries["removeComment"]["request"]): void;
}

function useRemoveComment(comment: Identifiable<Comment>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveCommentRequestPending(comment),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveCommentRequestSuccess(comment),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveCommentRequestFailure(comment),
    ),
    removeComment: core.removeComment,
  };
}

export { useRemoveComment };
